export default __webpack_public_path__ + "static/performance-question-d3ae73e4dbb0b372a26d7b233a8fb2d6.webp";